import styled from 'styled-components';

export const CustomTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
`;

export const StyledText = styled.span`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
`;
